export default __webpack_public_path__ + "static/media/Mittfisk.98aeb3a6.jpg";